<template>
  <v-dialog v-model="showDialog" max-width="380" persistent>

    <v-card v-if="noPointsDialog">
      <v-card-title>{{$t('congratsDialog.zeroPointsCongratsTitle')}}</v-card-title>
      <v-card-text>{{$t('congratsDialog.zeroPointsCongratsText')}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" to="/">OK</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="pointsDialog">
      <v-card-title>
        <h2 class="headline">{{$t('congratsDialog.title')}}</h2>
      </v-card-title>

      <v-card-text>
        <p>
          {{$tc('congratsDialog.congratsSubtitle', points, {count: points})}}
        </p>
        <div v-if="shouldRenderNextReachableRewards">
          <h5 class="subtitle-2" >{{$t('congratsDialog.nextClientBountyCaption')}}</h5>

          <v-row align="center" no-gutters class="flex-nowrap">
            <v-col class="avatar">
              <div class="avatar-container">
                <progress-circle :progress="bountyProgress" stroke="2"></progress-circle>
                <v-avatar class="reward-image">
                  <img v-if="bountyImage" :src="bountyImage" alt="">
                </v-avatar>
              </div>
            </v-col>

            <v-col class="text-left overview">
              <div class="section-header">
                <span class="subtitle-2 truncate">{{ bountyName }}</span>
              </div>

              <div class="points">
                <span><strong>{{ $t('bounties.redeemBountyPointsText', {count: bountyCrPoints}) }}</strong> / {{ bountyNeededPoints }}</span>
              </div>
            </v-col>
          </v-row>
        </div>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="closeDialog">{{nextButtonText}}</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  import {mapGetters} from 'vuex';
  import ProgressCircle from './ProgressCircle';

  export default {
    name: 'CongratsDialog',
    props: ['response', 'showDialog'],
    components: {
      ProgressCircle
    },
    data() {
      return {
        animationSpeed: 1,
        anim: false,
        points: false,
        shouldRenderNextReachableRewards: false,
        bountyImage: '',
        bountyCrPoints: false,
        bountyIsRedeemable: false,
        bountyName: '',
        bountyNeededPoints: false,
        bountyProgress: 0,
        pointsDialog: false,
        noPointsDialog: false
      }
    },
    computed: {
      ...mapGetters(['extensionSettings']),
      showCongratsDialog() {
        return this.showDialog
      },
      nextButtonText() {
        let text = this.$t('congratsDialog.next');
        if (this.$route.name === 'home') {
          text = this.$t('congratsDialog.close');
        }
        return text
      }
    },
    mounted() {
      this.points = _.get(this.response, 'loyalty_points', 0);
      const actions = _.get(this.response, 'actions', {});

      if (this.points === 0 && _.isEmpty(actions)) {
        this.noPointsDialog = true;
      } else {

        // TODO: hasCustomRatingScale

        this.pointsDialog = true;
        const nextBounty = _.get(this.response, 'next_redeemable_rewards.client');

        if (nextBounty) {
          this.shouldRenderNextReachableRewards = _.get(this.extensionSettings, 'loyalty.show_next_reachable_rewards', false) && this.points > 0;
          this.getBountyData(nextBounty);
        }
      }
      this.$store.dispatch('fetchCustomerRelationship');
    },
    methods: {
      getBountyData(bounty) {
        this.bountyImage = _.get(bounty, 'image');
        this.bountyCrPoints = _.get(bounty, 'cr_points', 0);
        this.bountyIsRedeemable = _.get(bounty, 'is_redeemable', false);
        this.bountyName = _.get(bounty, 'name', '');
        this.bountyNeededPoints = _.get(bounty, 'needed_points', 0);

        if (this.bountyNeededPoints === 0 || this.bountyCrPoints >= this.bountyNeededPoints) {
          this.bountyProgress = 1.0;
        } else {
          this.bountyProgress = this.bountyCrPoints / this.bountyNeededPoints;
        }
      },
      closeDialog() {
        this.$emit('hideDialog');
        let next = 'home'
        if (_.get(this.response, 'should_trigger_rating', false)) {
          next = 'user-rating';
        }
        // TODO: add functionality "facebookPosting" and "archiveReceipt"

        this.$router.push({name: next});
      }
    }
  }
</script>

<style scoped lang="scss">
  .truncate {
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
  .reward-image {
    margin-right: 10px;
  }
  .avatar-container {
    height: 48px;
    width: 48px;
    position: relative;
    &::v-deep .progress-circle {
      height: 52px;
      width: 52px;
      position: absolute;
      top: -2px;
      left: -2px;
      z-index: 2;
    }
  }
  .avatar {
    flex: none;
    width: 58px
  }
  .overview {
    flex: none;
    width: calc(100% - 85px);
  }
  h5 {
    margin-bottom: 1em;
  }
</style>
